<mon-page-toolbar
  titleTranslateKey="monitoring.menu.dashboard"
  [showFiltersButton]="false"
/>

<div class="dashboard">
  <mon-overview-dashboard />
  <mon-facilities-overview />
  <mon-last-equipment-events />
</div>
